import { frontendURL } from 'dashboard/helper/URLHelper';

const QuotesIndex = () => import('./pages/QuotesIndex.vue');
const SalesReport = () => import('./pages/SalesReport.vue');
const DeliveryPaymentReport = () => import('./pages/DeliveryPaymentReport.vue');
const ExpeditionIndex = () => import('./pages/ExpeditionIndex.vue');
const PromissoriaReport = () => import('./pages/PromissoriaReport.vue');
const CashClosingPage = () => import('./pages/CashClosingPage.vue');
const QuotesDashboard = () => import('./pages/QuotesDashboard.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/quotes'),
      name: 'quotes_dashboard_index',
      component: QuotesIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/sales-report'),
      name: 'sales_report',
      component: SalesReport,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/delivery-report'),
      name: 'delivery_payment_report',
      component: DeliveryPaymentReport,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/promissoria-report'),
      name: 'promissoria_report',
      component: PromissoriaReport,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/expedition'),
      name: 'expedition_index',
      component: ExpeditionIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/dashboard'),
      name: 'quotes_dashboard',
      component: QuotesDashboard,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/quotes/cash-closing'),
      name: 'cash_closing',
      component: CashClosingPage,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
